export var circularProgressTheme = {
  baseStyle: _ref => {
    var {
      strokeDasharray
    } = _ref;
    return {
      container: {
        width: '24px',
        height: '24px',
        display: 'inline-flex'
      },
      circle: {
        stroke: 'neutral.light',
        fill: 'transparent',
        strokeWidth: '10px'
      },
      track: {
        stroke: 'brand.main',
        strokeWidth: '10px',
        fill: 'transparent',
        opacity: 1,
        strokeDashoffset: 66,
        strokeDasharray,
        transitionProperty: 'stroke-dasharray, stroke',
        transitionDuration: '0.6s',
        transitionTimingFunction: 'ease',
        '&[data-progress="0"]': {
          opacity: 0
        }
      }
    };
  }
};
//# sourceMappingURL=CircularProgress.theme.js.map